export default "__VITE_ASSET__0b069069__"